<template>
  <div class="root">
    <p class="mode">
      <span>土地信息</span>
      <router-link to="/tudixinxi">更多></router-link>
    </p>
    <div class="contents">
      <div class="content" v-for="(item, index) in tdList" :key="index">
        <img :src="requestUrl + item.imgs[0].src" alt />
        <h3>{{ item.title }}</h3>
        <!-- <p>{{item.content}}</p> -->
        <p
          v-html="item.content"
          style="
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
            overflow: hidden;
          "></p>
        <router-link
          :to="{ name: '土地信息详情', query: { id: item.id } }"
          class="r"
          >【更多】</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tdList: [],
    }
  },
  created() {
    // 土地信息数据
    let url = 'tudixinxi'
    // console.log('土地信息');
    // console.log(this.ajax_url(url).data);
    this.tdList = this.ajax_url(url).data.slice(0, 2)

    for (let i = 0; i < this.tdList.length; i++) {
      this.tdList[i].content = this.tdList[i].content.replace(
        /<img/g,
        "<img style='display:none'"
      )
    }
    console.log(this.tdList)
  },
  mounted() {},
  computed: {},
  watch: {},
  methods: {},
}
</script>

<style scoped>
.root {
  width: 100%;
  height: 600px;
  background: #ffffff;
  box-shadow: 0px 0px 24px 0px rgba(21, 21, 21, 0.1);
  overflow: hidden;
}

.mode {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 0 61px 0 37px;
  /* width: 1174px; */
  height: 80px;
  color: #2187ff;
  border-bottom: 1px solid #6681ea;
}

.mode > span {
  display: block;
  width: auto;
  height: 50px;
  font-size: 37px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #2187ff;
  padding-left: 5px;
  border-left: #6681ea 6px solid;
  line-height: 50px;
}

.mode > a {
  display: block;
  width: auto;
  height: 80px;
  font-size: 25px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #6681ea;
  line-height: 80px;
}

.contents {
  display: flex;
  align-items: center;
  width: 100%;
  height: 623px;
  /* background-color: chartreuse; */
}

.content {
  display: block;
  margin-left: 69px;
  width: 532px;
  height: 516px;
  /* background-color: chocolate; */
  overflow: hidden;
}

.content > img {
  display: block;
  width: 532px;
  height: 298px;
}

.content > h3 {
  padding: 20px 0;
  width: 100%;
  height: 30px;
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.content > p {
  width: 100% !important;
  height: 60px;
  max-height: 116px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 30px;
  text-indent: 2em;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  text-overflow: ellipsis;
}

.content > p >>> :nth-child(2) {
  width: 532px !important;
}

.content > a {
  padding-top: 10px;
  width: auto;
  height: 20px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #2187ff;
  line-height: 20px;
}
</style>
